export default {"src":"/_next/static/media/mail.5fe9d635.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};